import React from 'react';

import Icon from '@ant-design/icons';
import SortDefault from '@icons/dimensions/sort-default.svg';
import SortUp from '@icons/dimensions/sort-up.svg';

export const constants = {
  ASC: 'asc',
  DESC: 'desc',
};

const Sorter = ({ sortOrder }) => {
  const SortIcon = () => {
    if (sortOrder === constants.ASC) {
      return <SortUp />;
    } else if (sortOrder === constants.DESC) {
      return <SortUp style={{ transform: 'rotate(180deg)' }} />;
    }
    return <SortDefault />;
  };
  return <Icon component={SortIcon} />;
};

export default Sorter;
